import React, {useState, useEffect} from "react"

function getReset() {
    const now = new Date()
    const days = now.getUTCDay() * 24 * 60 * 60
    const hours = now.getUTCHours() * 60 * 60
    const minutes = now.getUTCMinutes() * 60
    const seconds = days + hours + minutes + now.getUTCSeconds()
    return 7 * 24 * 60 * 60 - seconds
}

function Countdown(props) {
    const [countdown, setCountdown] = useState(getReset)

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(getReset())
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [])

    const format = (time) => {
        const zeros = (value) => value.toString().padStart(2, '0')
        const days = Math.floor(time / (24 * 60 * 60))
        const hours = Math.floor((time % (24 * 60 * 60)) / (60 * 60))
        const minutes = Math.floor((time % (60 * 60)) / 60)
        const seconds = time % 60
        return `${zeros(days)}:${zeros(hours)}:${zeros(minutes)}:${zeros(seconds)}`
    }

    return (
        <h3 id="countdown">{props.challengeID ? `#${props.challengeID.toString().padStart(4, '0')} | ` : ''}{format(countdown)}</h3>
    )
}

export default Countdown